import React, { useState, useEffect, useContext, useRef } from "react";
import "../../css_files/Master/SubCategoryMaster.css";
import Table from "../Homepage/Table";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import getCookie from "../../api";
import { triggerscroll } from "../Homepage/Homepage";
import AddMaster from "./AddMaster";
import SearchMaster from "./SearchMaster";
import Pagination from "../Homepage/Pagination";
import axiosInstance from "../../api";
import AddServiceReportMaster from "./AddServiceReportMaster";
import SearchServiceReportMaster from "./SearchServiceReportMaster";

function ServiceReportMaster() {
  const [showaddform, setshowaddform] = useState(false);
  const [showsearchform, setshowsearchform] = useState(false);
  const tablehead = ["Id", "Category Name", "SubCategory Names"];
  const [tabledata, setTableData] = useState([]);
  const [reload, setReload] = useState(false);
  const [triggerupdate, settriggerupdate] = useState(false);
  const [servicemasterupdatedata, setservicemasterupdatedata] = useState(null);
  const [datareload, setdatareload] = useState(0);
  const [loading, setloading] = useState(false);
  const { setExpiredSession, permissionsdata, userData } =
    useContext(triggerscroll);
  const [pagenumber, setpagenumber] = useState(1);
  const [pagecount, setpagecount] = useState(0);
  const [totalcount, setTotalCount] = useState(0);
  const [excelloading, setexcelloading] = useState(false);
  const [search, setSearch] = useState("");

  function fetchservicereportmasterdata(servicemasterid) {
    const url = `${process.env.REACT_APP_API_URL}/api/v1/ServiceReportMaster/GetSingleServiceReportCategory/${servicemasterid}`;
    axiosInstance
      .get(url)
      .then((res) => {
        setservicemasterupdatedata(res.data);
      })
      .catch(console.log);
  }

  useEffect(() => {
    setloading(true);
    const fetchservicereports = async () => {
      try {
        const response = await axiosInstance.post(
          `${process.env.REACT_APP_API_URL}/api/v1/ServiceReportMaster/GetAllServiceReportCategories/${pagenumber}`,
          {
            Search: search,
          }
        );
        setpagecount(response.data.count);
        setTotalCount(response.data.dataCount);
        setTableData(
          response.data.data.map((x) => [
            x.id,
            x.name,
            x.serviceReportMasterSubCategories
              ?.map((x) => x.name)
              ?.join(`, \n`),
          ])
        );
      } catch (error) {
        console.error(error);
      } finally {
        setloading(false);
      }
    };

    fetchservicereports();
  }, [reload, pagenumber]);

  return (
    <section className="sub-category-master">
      <h1>Service Report Master</h1>
      <blockquote className="sub-category-master-forms">
        <AddMaster
          text="Add Service Report Master"
          setshowaddform={setshowaddform}
          settriggerupdate={settriggerupdate}
          setshowsearchform={setshowsearchform}
          permit={() => false}
        />

        <SearchMaster
          text="Search Service Report Master"
          setshowsearchform={setshowsearchform}
          setshowaddform={setshowaddform}
        />
      </blockquote>
      {showaddform && (
        <AddServiceReportMaster
          setshowaddform={setshowaddform}
          reload={reload}
          setReload={setReload}
          triggerupdate={triggerupdate}
          servicemasterupdatedata={servicemasterupdatedata}
          key={`${servicemasterupdatedata?.id}-${triggerupdate}-${datareload}`}
        />
      )}
      {showsearchform && (
        <SearchServiceReportMaster
          setshowsearchform={setshowsearchform}
          setpagenumber={setpagenumber}
          setReload={setReload}
          setSearch={setSearch}
          reload={reload}
        />
      )}
      <Table
        tablehead={tablehead}
        tabledata={tabledata}
        setshowaddform={setshowaddform}
        settriggerupdate={settriggerupdate}
        fetchdata={fetchservicereportmasterdata}
        url="ServiceReportMaster/DeleteCategory"
        reload={reload}
        setReload={setReload}
        setdatareload={setdatareload}
        datareload={datareload}
        loading={loading}
        readPermission={() => true}
        updatePermission={() => false}
        deletePermission={() => false}
        totalcount={totalcount}
      />
      <Pagination
        count={pagecount}
        setpagenumber={setpagenumber}
        pagenumber={pagenumber}
      />
    </section>
  );
}

export default ServiceReportMaster;
